export function WaitingDelivery() {
  return <>Төлбөр дууссан/ хүргэлтийг хүлээж байна</>
}
{
  /*결제 완료/배송 대기 화면*/
}
